//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CrudTableHeader',

  props: {
    page: {
      type: Number,
      default: 1,
    },
    isMovementPage: {
      type: Boolean,
      default: false,
    },
    totalPages: {
      type: Number,
      default: undefined,
    },
    serverItemsLength: {
      type: Number,
      default: undefined,
    },
  },

  data: () => ({
    selectedOnCurrentPage: [],
    Page: 1,
  }),

  computed: {
    pagerPage: {
      get() {
        return this.page
      },
      set(value) {
        this.$emit('update:page', value)
      },
    },
  },
}
